@if (!externalUrl) {
  <main
    class="productized-auth"
    data-test-id="authenticationContainer"
    [zipBusy]="busy"
  >
    <!-- switch to change between layouts -->
    @switch (config?.layout) {
      @case (AuthenticationLayouts.banner) {
        <auth-banner [layoutOptions]="config?.layoutOptions">
          <ng-container
            authCard
            *ngTemplateOutlet="authCard"
            data-test-id="authLayoutBanner"
          ></ng-container>
        </auth-banner>
      }
      @case (AuthenticationLayouts.step) {
        <auth-step [layoutOptions]="config?.layoutOptions">
          <ng-container
            authCard
            *ngTemplateOutlet="authCard"
            data-test-id="authLayoutStep"
          ></ng-container>
        </auth-step>
      }
    }
    <ng-template #authCard>
      <auth-card
        (buttonClicked)="handleButtonClicked()"
        (linkClicked)="handleLinkClicked($event)"
        [disableButton]="disableButton"
        [success]="success"
        [errorMessage]="errorMessage"
        [formGroup]="formGroup"
        [config]="config?.authCardOptions"
        [date_of_birth]="subscriberDOB"
        [browserSupportConfig]="browserSupportConfig"
        data-test-id="authCard"
      >
      </auth-card>
    </ng-template>
  </main>
}
